//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import BurgerMenuIcon from './BurgerMenuIcon.vue';
import dayjs from 'dayjs';

export default {
  props: { menu: Array, onClose: Function, socialLinks: Object },
  data: function() {
    return {
      year: dayjs().year(),
    };
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/burger-menu/BurgerMenuDrawer.vue